import { FORM_SESSION_STATUS } from '../../utils/formSession';
import { FORM_TYPES } from '../../constants/formTypes';
import ACTIONS_TYPES from '../../constants/types';
import {
  ISelectOptions,
  ISelectOptionsDict,
} from '../../utils/interfaces/ISelectOptions';

export interface IFormSessionField {
  fieldCode: string;
  value: any;
}

export interface IMagicFieldsData {
  [key: string]: string;
}
export interface IFormSessionState {
  fields: IFormSessionField[];
  formDefId: string | null;
  formType: FORM_TYPES | null;
  language: string;
  status: FORM_SESSION_STATUS | null;
  token: string | null;
  tenantId: string | null;
  accreditationRequestId: string | null;
  credentialProfileId: string | null;
  eventId: string | null;
  projectId: string | null;
  eventsList: ISelectOptions[];
  continueAsGuest: boolean;
  loginEnabled: boolean;
  createAccountEnabled: boolean;
  magicFieldsData: IMagicFieldsData | null;
  dropdownList?: ISelectOptionsDict;
}

const initialState: IFormSessionState = {
  fields: [],
  formDefId: null,
  formType: null,
  language: 'en',
  status: null,
  token: null,
  tenantId: null,
  accreditationRequestId: null,
  credentialProfileId: null,
  eventId: null,
  projectId: null,
  eventsList: [],
  continueAsGuest: true,
  loginEnabled: true,
  createAccountEnabled: true,
  magicFieldsData: null,
  dropdownList: {},
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTIONS_TYPES.SET_FORM_SESSION:
      return { ...state, ...action.payload };
    case ACTIONS_TYPES.SET_FORM_SESSION_EVENTS_LIST:
      return { ...state, ...{ eventsList: action.payload } };
    case ACTIONS_TYPES.SET_FORM_SESSION_TOKEN:
      return { ...state, ...{ token: action.payload } };
    case ACTIONS_TYPES.SET_FORM_SESSION_DROPDOWN_LIST:
      return {
        ...state,
        ...{
          dropdownList: { ...state.dropdownList, ...action.payload },
        },
      };
    case ACTIONS_TYPES.RESET_FORM_SESSION:
      return { ...initialState };
    default:
      return state;
  }
}
